import { computed } from '@vue/composition-api';
import { date } from '@/util/formatters';
import { OfferStatus } from '@/api/v2/requests/offers';
import { GoodsOfferStatus } from '@/api/v2/requests/goods-offers';
import { DummyFilter } from '@/components/Table/dummy-filter';
export const useUnifiedOfferColumns = (ctx) => {
    const columns = computed(() => {
        return [
            {
                field: 'internalNumber',
                headerName: '#',
                sortable: true,
                width: 115,
                minWidth: 115,
                flex: 0,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
            },
            {
                field: 'title',
                headerName: ctx.root.$t('brand-offers.title').toString(),
                flex: 1,
                minWidth: 150,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
            },
            {
                field: 'centralCostName',
                headerName: ctx.root.$t('brand-offers.cost-center').toString(),
                flex: 1,
                minWidth: 150,
                sortable: true,
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingTextFilter',
                suppressFloatingFilterButton: true,
            },
            {
                field: 'status',
                headerName: ctx.root.$t('brand-offers.status').toString(),
                width: 280,
                sortable: true,
                cellRenderer: 'UnifiedOfferStatusCell',
                cellRendererParams: (params) => ({
                    status: params?.data.status,
                }),
                filter: DummyFilter,
                floatingFilter: true,
                floatingFilterComponent: 'FloatingSelectFilter',
                floatingFilterComponentParams: () => {
                    const allowedStatuses = [
                        OfferStatus.ACTIVE,
                        OfferStatus.APPROVED,
                        OfferStatus.CONTRACT,
                        OfferStatus.RESERVED,
                        OfferStatus.ARCHIVED,
                    ];
                    const offerStatusOptions = Object.values(OfferStatus)
                        .filter((status) => allowedStatuses.includes(status))
                        .map((status) => ({
                        value: status,
                        label: `[OBJ] ${status}`,
                    }));
                    const goodsOfferStatusOptions = Object.values(GoodsOfferStatus)
                        .filter((status) => status !== GoodsOfferStatus.DRAFT)
                        .map((status) => ({
                        value: status,
                        label: `[G&S] ${status}`,
                    }));
                    return {
                        options: [...offerStatusOptions, ...goodsOfferStatusOptions],
                        getLabel: (status) => {
                            if (Object.values(OfferStatus).includes(status)) {
                                const translation = ctx.root
                                    .$t(`offer-status.${status}`)
                                    .toString();
                                return `[OBJ] ${translation}`;
                            }
                            const translation = ctx.root
                                .$t(`goods-offer-status.${status}`)
                                .toString();
                            return `[G&S] ${translation}`;
                        },
                    };
                },
                suppressFloatingFilterButton: true,
            },
            {
                field: 'createdAt',
                headerName: ctx.root.$t('brand-offers.created').toString(),
                sortable: true,
                cellRenderer: (params) => date(params?.data.createdAt),
            },
        ];
    });
    return { columns };
};
